import React, { useState } from "react";
import { API_BASE_URL } from "../../../../api/api";
import { Link } from "react-router-dom";
import { StarRating } from "../../../common/StarRating";
import { getInitials, getPracticeMapUrl } from "../../../../utils/helper";

const CompareModal = ({
  items,
  setIsCompareModal,
  setSelectedComparisons,
  services,
  setIsInquiryEmailSend,
  setSelectedPractice,
}) => {
  return (
    <>
      <div className="container mx-auto bg-white rounded-xl sm:rounded-2xl px-3 py-3  innercard h-[90vh] ">
        <div className="flex justify-between border-b pb-3">
          <h2 className="text-dark font-bold text-2xl">Compare</h2>
          <button
            type="button"
            onClick={() => setIsCompareModal(false)}
            className="cancelbtn"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5859 12.0001L2.79297 4.20718L4.20718 2.79297L12.0001 10.5858L19.793 2.79297L21.2072 4.20718L13.4143 12.0001L21.2072 19.7929L19.793 21.2072L12.0001 13.4143L4.20718 21.2072L2.79297 19.7929L10.5859 12.0001Z"
                fill="black"
              ></path>
            </svg>
          </button>
        </div>
        <div className="overflow-y-auto no-scrollbar h-[calc(100%-45px)] pt-3">
          <table>
            <thead>
              <tr>
                <th className="min-w[120px] lg:min-w-[190px] md:max-w-[190px] px-2 py-4 align-top"></th>
                {items?.length > 0 &&
                  items.map((item, index) => (
                    <th
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top w-1/3 min-w-[180px] sm:min-w-[280px]"
                    >
                      <div className="flex flex-col">
                        <div className="flex justify-between items-start">
                          <div className="aspect-square max-w-[80px] rounded border-[5px] border-white overflow-hidden">
                            {item.image ? (
                              <img
                                src={
                                  item.image ? API_BASE_URL + item.image : null
                                }
                                alt=""
                                srcset=""
                                className="rounded object-cover object-center"
                              />
                            ) : (
                              <div className="bg-gray-200 text-gray-700 font-semibold text-lg flex items-center justify-center w-full h-full rounded-lg overflow-hidden">
                                <p className="p-10">
                                  {item?.practice_name &&
                                    getInitials(item?.practice_name)}
                                </p>
                              </div>
                            )}
                          </div>
                          <button
                            onClick={() =>
                              setSelectedComparisons((prev) =>
                                prev.filter(
                                  (compareItem) =>
                                    compareItem.practices_id !==
                                    item.practices_id
                                )
                              )
                            }
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.7075 2.80692C7.58692 1.55113 9.79651 0.880859 12.0569 0.880859C15.0867 0.884779 17.9914 2.09012 20.1338 4.23254C22.2762 6.37496 23.4815 9.27959 23.4854 12.3094C23.4854 14.5698 22.8151 16.7794 21.5594 18.6588C20.3036 20.5382 18.5187 22.003 16.4303 22.8681C14.3421 23.7331 12.0442 23.9594 9.82729 23.5184C7.61036 23.0774 5.57397 21.989 3.97565 20.3907C2.37734 18.7923 1.28887 16.756 0.847898 14.539C0.406925 12.3221 0.633246 10.0242 1.49824 7.93591C2.36325 5.8476 3.82809 4.06271 5.7075 2.80692ZM6.86309 20.0822C8.40033 21.1099 10.2078 21.6587 12.0569 21.6592C14.5362 21.6572 16.9134 20.6716 18.6668 18.9187C20.4203 17.1658 21.4065 14.7888 21.4091 12.3094C21.4091 10.4603 20.8609 8.65276 19.8335 7.11525C18.8063 5.57774 17.3462 4.37936 15.6379 3.67163C13.9295 2.96389 12.0498 2.7786 10.2362 3.13916C8.42259 3.49972 6.75663 4.38995 5.44895 5.69728C4.14126 7.00462 3.25058 8.67036 2.88954 10.4839C2.5285 12.2973 2.71332 14.1772 3.4206 15.8857C4.12788 17.5942 5.32586 19.0546 6.86309 20.0822ZM16.8977 6.90016C17.0247 6.95342 17.1401 7.03143 17.2367 7.12966C17.4314 7.32455 17.5407 7.58874 17.5407 7.86416C17.5407 8.1396 17.4314 8.40377 17.2367 8.59867L13.5334 12.302L17.2367 16.0054C17.4314 16.2003 17.5407 16.4644 17.5407 16.7398C17.5407 17.0153 17.4314 17.2795 17.2367 17.4744C17.1404 17.5732 17.0252 17.6518 16.898 17.7054C16.7708 17.759 16.6341 17.7867 16.4961 17.7867C16.3581 17.7867 16.2214 17.759 16.0942 17.7054C15.967 17.6518 15.8518 17.5732 15.7555 17.4744L12.0521 13.771L8.34873 17.4744C8.25235 17.5732 8.13718 17.6518 8.00997 17.7054C7.88277 17.759 7.7461 17.7867 7.60805 17.7867C7.47001 17.7867 7.33337 17.759 7.20617 17.7054C7.07895 17.6518 6.96375 17.5732 6.86738 17.4744C6.77042 17.3782 6.69348 17.2638 6.64095 17.1378C6.58843 17.0117 6.56135 16.8764 6.56135 16.7398C6.56135 16.6033 6.58843 16.4681 6.64095 16.342C6.69348 16.216 6.77042 16.1016 6.86738 16.0054L10.5707 12.302L6.86738 8.59867C6.77092 8.5014 6.69459 8.38608 6.6427 8.25932C6.5908 8.13254 6.56441 7.99678 6.56498 7.85981C6.56555 7.72283 6.59309 7.58729 6.64605 7.46095C6.699 7.33462 6.77629 7.21995 6.87356 7.12349C6.97083 7.02704 7.08614 6.95069 7.21291 6.89879C7.33968 6.84691 7.47543 6.8205 7.61242 6.82107C7.7494 6.82164 7.88493 6.84919 8.01126 6.90214C8.13761 6.95509 8.25227 7.0324 8.34873 7.12966L12.0521 10.833L15.7555 7.12966C15.8522 7.03143 15.9675 6.95342 16.0946 6.90016C16.2218 6.84692 16.3582 6.81949 16.4961 6.81949C16.634 6.81949 16.7705 6.84692 16.8977 6.90016Z"
                                fill="black"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        <hr className="border-2 border-lightblue my-3" />
                        <h2 className="text-dark font-semibold text-xl lg:text-2xl flex text-left items-start gap-2 mb-3.5">
                          <Link
                            to={
                              item.is_practitioner === 0
                                ? `/${item?.postcode?.postcode}/${services}-in-${item?.suburb?.slug}/${item?.slug}`
                                : `/${item?.postcode?.postcode}/${services}-in-${item?.suburb?.slug}/${item?.practice?.slug}/${item?.slug}`
                            }
                          >
                            {item?.practice_name}
                          </Link>{" "}
                          {item?.is_verified == 1 && (
                            <span>
                              <img
                                src="/assets/image/verifiedicon.svg"
                                alt=""
                                srcset=""
                                className="min-h-5 min-w-5 h-6 w-6 "
                              />
                            </span>
                          )}
                        </h2>
                        {item?.address && (
                          <Link
                            to={getPracticeMapUrl(item)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className=" flex gap-2 text-left mb-3.5"
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="w-4 h-4 sm:h-6 sm:w-6"
                            >
                              <path
                                d="M18.364 17.364L12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
                                fill="#0052CC"
                              ></path>
                            </svg>
                            <span className="w-[calc(100%-20px)] sm:w-[calc(100%-32px)] font-medium text-dark underline text-sm sm:text-base">
                              {item?.address}, {item?.suburb?.name}{" "}
                              {item?.state?.name} {item?.postcode?.postcode}
                            </span>
                          </Link>
                        )}
                        <span className="text-left text-green text-sm sm:text-base font-medium">
                          {item?.services
                            ?.map((service) => service.name)
                            .join(", ")}
                        </span>
                      </div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-top">
                  Review
                </td>
                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      <StarRating
                        rating={Number(item?.reviews?.reviews_avg) || 0}
                        reviews_count={item?.reviews?.reviews_count}
                      />
                    </td>
                  ))}
              </tr>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-top">
                  Services &amp; Fees
                </td>
                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      <span className="flex items-center">
                        <span className="mx-1 text-green text-sm sm:text-base font-medium">
                          {item?.services_fees?.length > 0 ? (
                            <>
                              {item?.services_fees.map(
                                (services_fees_item, servicesIndex) => (
                                  <p key={servicesIndex}>
                                    {services_fees_item?.name} -{" "}
                                    {services_fees_item?.fees}
                                  </p>
                                )
                              )}
                            </>
                          ) : null}
                        </span>
                      </span>
                    </td>
                  ))}
              </tr>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-top">
                  Overview
                </td>

                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      <p className="text-dark text-xs sm:text-sm font-medium text-ellipsis line-clamp-3">
                        {item?.full_description?.length > 100
                          ? `${item.full_description.slice(0, 100)}... `
                          : item.full_description + ' '}
                        <Link
                            to={
                              item.is_practitioner === 0
                                ? `/${item?.postcode?.postcode}/${services}-in-${item?.suburb?.slug}/${item?.slug}`
                                : `/${item?.postcode?.postcode}/${services}-in-${item?.suburb?.slug}/${item?.practice?.slug}/${item?.slug}`
                            }
                          className="underline text-xs sm:text-sm font-medium text-green"
                        >
                          View more
                        </Link>
                      </p>
                    </td>
                  ))}
              </tr>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-middle">
                  Photos
                </td>

                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      {/* <div className="flex gap-3">
                        <a href="physiotherapist-details.html">
                          <img
                            src="/assets/image/Image-placeholder.png"
                            className="h-8 w-8 sm:h-12 sm:w-12 object-cover object-center rounded-lg"
                            alt=""
                          />
                        </a>
                        <a href="physiotherapist-details.html">
                          <img
                            src="/assets/image/Image-placeholder.png"
                            className="h-8 w-8 sm:h-12 sm:w-12 object-cover object-center rounded-lg"
                            alt=""
                          />
                        </a>
                        <a href="physiotherapist-details.html">
                          <img
                            src="/assets/image/Image-placeholder.png"
                            className="h-8 w-8 sm:h-12 sm:w-12 object-cover object-center rounded-lg"
                            alt=""
                          />
                        </a>
                      </div> */}
                    </td>
                  ))}
              </tr>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-top">
                  FAQs
                </td>

                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      <Link
                            to={
                              item.is_practitioner === 0
                                ? `/${item?.postcode?.postcode}/${services}-in-${item?.suburb?.slug}/${item?.slug}`
                                : `/${item?.postcode?.postcode}/${services}-in-${item?.suburb?.slug}/${item?.practice?.slug}/${item?.slug}`
                            }
                        className="underline text-xs sm:text-sm font-medium text-green"
                      >
                        View FAQs
                      </Link>
                    </td>
                  ))}
              </tr>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-middle">
                  Call
                </td>
                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      <Link
                        to={`tel:${item?.phone}`}
                        className="bg-green text-center text-white text-xs sm:text-sm font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-green md:max-w-[200px]"
                      >
                        Call {item?.practice_name}
                      </Link>
                    </td>
                  ))}
              </tr>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-middle">
                  Email
                </td>
                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      {/* <Link
                        to={`mailto:${item?.email}`}
                        className="bg-transparent text-center text-dark text-xs sm:text-sm font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3  sm:px-0 flex items-center justify-center border border-dark emailButton md:max-w-[200px]"
                      >
                        Email {item?.practice_name}
                      </Link> */}
                      <button
                        onClick={() => {
                          setIsCompareModal(false);
                          setIsInquiryEmailSend(true);
                          setSelectedPractice(item);
                        }}
                        className="bg-transparent text-center text-dark text-xs sm:text-sm font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3  sm:px-0 flex items-center justify-center border border-dark emailButton md:max-w-[200px]"
                      >
                        Email {item?.practice_name}
                      </button>
                    </td>
                  ))}
              </tr>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-middle">
                  Book Appointment
                </td>
                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      {item?.book_appointment_link && (
                        <Link
                          to={
                            item?.book_appointment_link
                              ? item.book_appointment_link.startsWith("http://") || item.book_appointment_link.startsWith("https://")
                                ? item.book_appointment_link
                                : `https://${item.book_appointment_link}`
                              : "#"
                          }  
                          target="_blank"
                          className="bg-transparent text-center text-dark text-xs sm:text-sm font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3  sm:px-0 flex items-center justify-center border border-dark md:max-w-[200px]"
                        >
                          Book Appointment
                        </Link>
                      )}
                    </td>
                  ))}
              </tr>
              <tr>
                <td className="px-2 py-4 text-sm sm:text-base font-medium text-dark align-middle">
                  Website
                </td>
                {items?.length > 0 &&
                  items.map((item, index) => (
                    <td
                      key={index}
                      className="px-2 py-4 border-r-4 border-lightblue last:border-r-0 align-top"
                    >
                      {item?.website_link && (
                        <Link
                          to={
                            item?.website_link
                              ? item.website_link.startsWith("http://") || item.website_link.startsWith("https://")
                                ? item.website_link
                                : `https://${item.website_link}`
                              : "#"
                          }                          
                          target="_blank"
                          className="bg-transparent text-center text-dark text-xs sm:text-sm font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3  sm:px-0 flex items-center justify-center border border-dark md:max-w-[200px]"
                        >
                          View Website
                        </Link>
                      )}
                    </td>
                  ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CompareModal;
